import { render } from "./Entrada.vue?vue&type=template&id=275f63e6&scoped=true"
import script from "./Entrada.vue?vue&type=script&lang=js"
export * from "./Entrada.vue?vue&type=script&lang=js"

import "./Entrada.vue?vue&type=style&index=0&id=275f63e6&scoped=true&lang=css"
import "./Entrada.vue?vue&type=style&index=1&id=275f63e6&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275f63e6"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QFile,QIcon,QBtn,QField});
